import { StyleRules } from '@material-ui/core';
import Colors from '../colors/colors';

export default (): StyleRules => ({
  paper: {},
  paperBackground: {
    backgroundColor: Colors.backgroundGrey,
  },
});
